import { Room } from "@/core/api/room.api";
import { BaseApi } from "@/core/api/base.api";
import { roomTranslationService } from "@/core/service/room.translation.service";

class RoomTranslationApi extends BaseApi {
  #translation = {
    use: false,
    sourceLang: "ko-KR",
    targetLang: "EN-US",
    type: "AZURE",
  };
  constructor() {
    super();
    Room.Translation = this;
    Room.addEventListeners(this._CoreEvents, this);
    Room.ready(async (e) => {
      try {
        const {
          roomInfo: {
            setting: { translationType, useTranslation, useForcedTranslation },
          },
        } = Room.getRoomData();

        if (translationType) {
          this.#translation.type = translationType.toUpperCase();
        }
        if (useForcedTranslation) {
          this.#translation.use = true
        }
        if (useTranslation) {
          this._eventListen(this.#Events);
          this._eventListen(this._CoreEvents);
        }
      } catch (e) {
        console.warn(e);
      }
    });
  }

  async onTranslationCallback(data) {
    if (!this.#translation.use) {
      return;
    }
    if (!data?.text) {
      return;
    }

    data.text.trim();
    if (
      data.text === "…" ||
      data.text === "아." ||
      data.text === "어." ||
      data.text === "으." ||
      data.text.length < 1
    )
      return;

    const { text, detectSourceLang, syncTranslationUUID } = data;
    await this.translationText({
      text,
      sourceLang: detectSourceLang ?? this.#translation.sourceLang,
      targetLang: this.#translation.targetLang,
      eventName: 'add_translation_text',
      eventPublish: true,
      translationType: this.#translation.type,
      syncTranslationUUID
    })
  }

  async translationText(data) {
    const body = { translationType: this.#translation.type, ...data }
    return await roomTranslationService.translationText(body);
  }

  enableTranslation(data) {
    const { enable, sourceLang, targetLang } = data;
    this.setTranslationInfo(sourceLang, targetLang);
    this.#translation.use = enable;
  }

  getTranslationUse(){
    return this.#translation.use;
  }

  setTranslationInfo(sourceLang, targetLang) {
    if (sourceLang) {
      this.#translation.sourceLang = sourceLang;
    }
    if (targetLang) {
      this.#translation.targetLang = targetLang;
    }
  }

  #Events = {
    add_translation_text: function (e) {
      Room.emit(e);
    },
    add_translation_text_error: function (e) {
      Room.emit(e);
    },
    add_meetingNote_summary_translation: function (e) {
      Room.emit(e);
    },
    add_meetingNote_summary_translation_error: function (e) {
      Room.emit(e);
    },
  };

  _CoreEvents = {
    room_core_call_translate_text: function (e) {
      this.onTranslationCallback(e.data);
    },
  };
}

export const roomTranslationApi = new RoomTranslationApi();
